<div>
    <div class="general-stake-container__title">{{ stakeAllSelectionsTitle() }}</div>
    <div class="general-stake-container__info">{{ stakeAllSelectionsInfo }}</div>
</div>
<bs-linear-single-bet-general-stake />
